import { formatCurrencyDefault } from "@/hooks/use-price";
import { EXeroPaymentStatus, IXeroPayment } from "@/utilities/types/Payment";
import cn from "@/utils/class-names";
import { Text } from "rizzui";

export interface PaymentPriceProps {
  payment: IXeroPayment;
  className?: string;
}

export default function PaymentPrice({
  payment,
  className,
}: PaymentPriceProps) {
  const xeroInvoice =
    payment.xeroPaymentHistories?.[payment.xeroPaymentHistories?.length - 1];

  const totalPaid = payment.xeroPaymentHistories?.reduce((acc, history) => {
    return acc + (history?.paid ? +history.paid : 0);
  }, 0);

  const paymentPrice: Record<
    string,
    {
      label: string;
      value: any;
      isHide?: boolean;
      isBold?: boolean;
    }
  > = {
    packagePrice: {
      label: "Sub total",
      value: payment.package?.price,
    },
    // voucher: {
    //   label: "Voucher",
    //   value: payment.package?.price,
    // },
    discountPrice: {
      label: "Discount",
      value: xeroInvoice?.discountPrice,
      isHide: xeroInvoice?.discountPrice === payment.package?.price,
    },
    // totalTax: {
    //   label: "Total Tax",
    //   value: xeroInvoice?.totalTax,
    // },
    totalDue: {
      label: "Total Due",
      value: xeroInvoice?.totalDue,
      isBold: true,
    },
    // total: {
    //   label: "Total",
    //   value: xeroInvoice?.total,
    // },
    totalPaid: {
      label: "Total Paid",
      value: totalPaid,
      isHide: payment.status === EXeroPaymentStatus.SUCCEED ? false : true,
    },
  };

  return (
    <div className={className}>
      {Object.entries(paymentPrice).map(([key, value]) => {
        return (
          !value?.isHide && (
            <div className={cn("flex justify-between mb-2")} key={key}>
              {value?.isBold ? (
                <>
                  <Text className="text-gray-700 font-bold">
                    {value?.label}:
                  </Text>
                  <Text className="font-bold">
                    {formatCurrencyDefault(value?.value || 0)}
                  </Text>
                </>
              ) : (
                <>
                  <Text className="text-gray-600">{value?.label}:</Text>
                  <Text className="font-medium">
                    {formatCurrencyDefault(value?.value || 0)}
                  </Text>
                </>
              )}
            </div>
          )
        );
      })}
    </div>
  );
}
